import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFridge: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFridge"><Path fillRule="evenodd" clipRule="evenodd" d="M20 2H4V10H20V2ZM16 8V5H14V8H16Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M20 12H4V22H20V12ZM16 14V17H14V14H16Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFridge;
